import { FlexBox, Text } from '@fable/components'
import { css } from '@fable/theme'
import { useMomBooksGrid } from './useMomBooksGrid'
import { useStatsTheme } from '../../../theme/ctx'

export const MomBooksGridX = () => {
  const { columnCount } = useMomBooksGrid()
  const theme = useStatsTheme((s) => s.theme)
  const xAxisIncrement = 5

  return (
    <div
      className={css`
        margin-top: 4px;
        display: grid;
        grid-template-columns: repeat(${columnCount}, 1fr);
        position: relative;
        opacity: 0.5;
      `}
    >
      {Array.from({ length: columnCount }).map((_, i) => (
        <FlexBox key={i}>
          <FlexBox
            className={css`
              position: relative;
            `}
            flexDirection="column"
            alignItems="center"
          >
            <span
              className={css`
                width: 1px;
                height: 2px;
                background-color: ${theme.colors.section.textSecondary};
              `}
            />
            {i % xAxisIncrement === 0 ? (
              <Text
                className={css`
                  position: absolute;
                  top: 4px;
                `}
                type="label"
                sizing="S"
                weight="500"
                color={theme.colors.section.textSecondary}
                align="center"
              >
                {i.toString()}
              </Text>
            ) : null}
          </FlexBox>
        </FlexBox>
      ))}
      <FlexBox
        className={css`
          position: absolute;
          top: 0;
          right: 0;
        `}
        flexDirection="column"
        alignItems="center"
      >
        <span
          className={css`
            width: 1px;
            height: 2px;
            background-color: ${theme.colors.section.textSecondary};
          `}
        />
        {columnCount % xAxisIncrement === 0 ? (
          <Text
            className={css`
              position: absolute;
              top: 4px;
            `}
            type="label"
            sizing="S"
            weight="500"
            color={theme.colors.section.textSecondary}
            align="center"
          >
            {columnCount}
          </Text>
        ) : null}
      </FlexBox>
    </div>
  )
}
